import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    actions: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: 1,
      mt: 3,
    },
    button: {
      fontSize: 14,
      py: 1.5,
    },
    slider: {
      width: 'calc(100% - 6px)',
      '& .MuiSlider-root': {
        padding: '10px 0',
      },
      '& span': {
        color: appTheme.mainColor,
      },
      '& .MuiSlider-thumb': {
        width: 12,
        height: 12,
      },
      '& .MuiSlider-thumb:after': {
        width: 24,
        height: 24,
      },
      '& .MuiSlider-rail': {
        backgroundColor: colors.grey_third,
      },
      '& .MuiSlider-track': {
        border: 0,
      },

      [breakpoints.down(ScreenSizes.Pc)]: {
        width: '94%',
      },
    },
    label: {
      color: colors.white,
      fontWeight: 500,
      fontSize: 14,
      lineHeight: 1.5,
      letterSpacing: '0.02em',
      marginBottom: 0.5,
    },
  };
};
